import { memo } from 'react';
import flow from 'lodash/flow';
import { TPlans } from 'types/plans.types';
import { Cart } from 'types/cart.types';
import { Sku } from 'types/sku.types';
import PlanModal from './PlanModal';

type PlanModalProps = {
  plan: TPlans;
  cart: Cart;
  sku: Sku;
};

const enhance = flow(
  Component =>
    ({ plan, sku, ...rest }: PlanModalProps) => <Component {...rest} plan={plan} sku={sku} />,
  memo,
);

export default enhance(PlanModal);
